import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <h4 class="mb-3 bold text-center">Rimarkis Roma orator’…</h4>

    <div class="poem">
      <p class="poem-block mb-3">
        Rimarkis roma orator’ <br/>
        Dum la tempest’ civilmilita: <br/>
        «En nokt’ de l’ Rom’ pereigita <br/>
        Ekvivis mi en morna hor’». <br/>
        Jes! – Sed la brilo adiaŭa <br/>
        De l’ sanga kaj majesta stel’ <br/>
        Rememorigos pri la bel’ <br/>
        De l’ Roma gloro hieraŭa!
      </p>
    </div>
    

    <h4 class="mt-5 mb-3 bold text-center">Naturo estas sfinks’…</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Naturo estas sfinks’. Kaj des pli certe ĝi <br/>
        Per sia tento pereigas homon, <br/>
        Ĉar eble, de pratempo ĝian nomon <br/>
        Mister’ neniu ombras per vizi’.
      </p>
    </div>


    <h4 class="mt-5 mb-3 bold text-center">SILENTIUM!</h4>


    <div class="poem">
      <p class="poem-block mb-3">
        Silentu, kaŝu en sekret’ <br/>
        Vi sentojn, revojn en kviet’. <br/>
        En la profundo de l’ anim’ <br/>
        Cirkulu ili en intim’, <br/>
        Kvazaŭ stelar’ en firmament’, - <br/>
        Vi ĝuu ilin en silent’. <br/>
        Kiel la kor’ esprimu sin? <br/>
        Ĉu malfermiĝu via sin’ <br/>
        Por aliulo kun raport’? <br/>
        Sed penson ne esprimas vort’! <br/>
        La akvojn fuŝos turbulent’, - <br/>
        Vi trinku ilin en silent’. <br/>
        En via kor’ troviĝas mond’: <br/>
        Mirakla kaj mistera rond’ <br/>
        De l’ pensoj, pretaj por detru’; <br/>
        Ĝin neniigos ajna bru’, <br/>
        Blindigos sun’, dispelos vent’, - <br/>
        Aŭskultu ilin en silent’!
      </p>
    </div>
  `
  )
}

const itemName = {
  esp: 'Fedor Tjutĉev'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemTranslator: translator.esp
  }
}

export default item;

